module.exports = __webpack_public_path__ + "img/zakarp_energo.ee609781.png";